import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b8070606&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8070606')) {
      api.createRecord('b8070606', component.options)
    } else {
      api.reload('b8070606', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=b8070606&", function () {
      api.rerender('b8070606', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMy/child/main.vue"
export default component.exports